module.exports = __webpack_public_path__ + "img/prize@2x.4c597680.png";